import { useThemeProvider } from "gsintegrations";
import { type CSSProperties } from "react";
import { Toaster } from "sonner";

const AppToaster = () => {
  const { mode } = useThemeProvider();
  const isDark = mode === "dark";

  const palette = isDark
    ? {
        background: "#1f1f1f",
        text: "#f5f5f5",
        description: "#d4d4d4",
        border: "1px solid #3a3a3a",
        warningBackground: "#3a2a00",
        warningText: "#ffe08a",
        warningBorder: "1px solid #8a6a00",
        actionBackground: "#f5f5f5",
        actionText: "#111111",
        cancelBackground: "transparent",
        cancelText: "#f5f5f5",
      }
    : {
        background: "#ffffff",
        text: "#111111",
        description: "#424242",
        border: "1px solid #d9d9d9",
        warningBackground: "#fff9e6",
        warningText: "#7a4e00",
        warningBorder: "1px solid #f0d58a",
        actionBackground: "#111111",
        actionText: "#ffffff",
        cancelBackground: "transparent",
        cancelText: "#111111",
      };

  return (
    <Toaster
      theme={isDark ? "dark" : "light"}
      position="top-center"
      closeButton
      toastOptions={{
        duration: 4000,
        style: {
          background: palette.background,
          color: palette.text,
          border: palette.border,
          // Sonner color tokens for default and warning toasts.
          "--normal-bg": palette.background,
          "--normal-text": palette.text,
          "--normal-border": palette.border,
          "--normal-description": palette.description,
          "--warning-bg": palette.warningBackground,
          "--warning-text": palette.warningText,
          "--warning-border": palette.warningBorder,
          "--warning-description": palette.warningText,
        } as CSSProperties,
        actionButtonStyle: {
          background: palette.actionBackground,
          color: palette.actionText,
          border: isDark ? "1px solid #5a5a5a" : "1px solid #111111",
        },
        cancelButtonStyle: {
          background: palette.cancelBackground,
          color: palette.cancelText,
          border: isDark ? "1px solid #5a5a5a" : "1px solid #bdbdbd",
        },
      }}
    />
  );
};

export default AppToaster;
